import styled, { css } from 'styled-components';
import { layout } from 'src/components/base';
import { Link as LinkComponent } from 'react-router-dom';
import {
  PrimaryButton as PrimaryButtonComponent,
  OutlinedButton as OutlinedButtonComponent,
} from '@prisjakt/ui/button/variants';

import { IconCheckFilled } from '@prisjakt/ui/icon/check-filled';
import { IconCloseFilled } from '@prisjakt/ui/icon/close-filled';

const sharedIconStyles = css`
  margin-bottom: ${layout.measurements.spacing050};
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Title = styled.h2`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
`;

export const SubmitMessage = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

export const Message = styled.div`
  width: 100%;
  display: flex;
  flex: 1 0 auto;
  flex-direction: column;
  align-items: center;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: ${layout.measurements.spacing050};
`;

const ButtonStyles = css`
  margin-left: ${layout.measurements.spacing050};
  margin-right: ${layout.measurements.spacing050};
  margin-bottom: ${layout.measurements.spacing050};
  width: 122px;
`;

export const PrimaryButton = styled(PrimaryButtonComponent)`
  ${ButtonStyles};
`;

export const OutlinedButton = styled(OutlinedButtonComponent)`
  ${ButtonStyles};
`;

export const Steps = styled.ul`
  list-style: none;
`;

export const Step = styled.li`
  &:not(:last-child) {
    margin-bottom: ${layout.measurements.spacing150};
  }
`;

export const SubTitle = styled.h6`
  font-size: ${layout.fontSizes.h6.desktop.rem};
`;

export const Text = styled.p`
  margin-bottom: ${layout.measurements.spacing050};
`;

export const SubText = styled.span`
  font-size: 12px;
  color: ${p => p.theme.text.quaternary};
`;

export const Link = styled(LinkComponent)`
  color: ${props => props.theme.text.linkExternal};
  text-decoration: underline;

  &:hover {
    color: ${p => p.theme.text.linkExternalHover};
  }
`;

export const StoresList = styled.ul`
  list-style: none;
`;

export const Divider = styled.div`
  background: ${p => p.theme.lines.primary};
  height: 1px;
  width: 100%;
  margin-top: ${layout.measurements.spacing100};
  margin-bottom: ${layout.measurements.spacing150};
`;

export const CheckIcon = styled(IconCheckFilled)`
  ${sharedIconStyles};
`;

export const ErrorIcon = styled(IconCloseFilled)`
  ${sharedIconStyles};
`;

export const Input = styled.input`
  width: 100%;
  margin-top: ${layout.measurements.spacing050};
  margin-bottom: ${layout.measurements.spacing050};
  border: 1px solid ${p => p.theme.lines.secondary};
  padding: 5px;
  outline: 0;
  height: 40px;
  border-radius: 4px;
  background-color: ${p => p.theme.colors.base0};

  &:focus {
    border-color: ${p => p.theme.colors.maybeBlue700};
    box-shadow: inset 0 0 0 1px ${p => p.theme.colors.maybeBlue700};
  }
`;
